import { setAnalytics } from '../../../thd-analytics-utils';
import { PAGE_DEFAULT_TEMPLATE } from '../../../constants';

const MAGIC_DOER_PAGE_LOAD_EVENT = 'magic doer page view';

export const magicDoer = () => {
  // MD 1.1 Magic Doer Page Load Tracking
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('magic-doer.page-load', ({ output = {} }) => {
    const {
      pageName = '',
      pageType = '',
      category = '',
      sessionID = ''
    } = output;
    digitalData.page = {
      category: {
        primaryCategory: category,
        subCategory1: category,
        subCategory2: category
      },
      pageInfo: {
        pageName,
        pageTemplate: PAGE_DEFAULT_TEMPLATE,
        pageType,
        pageLoadEvent: MAGIC_DOER_PAGE_LOAD_EVENT
      },
      mdSessionID: sessionID
    };
    setAnalytics(digitalData);
  });
};
